module.exports = __webpack_public_path__ + "img/lipinquan.49110bc6.png";